import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { difference } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';

import { ButtonComponent } from '@shared/components/button/button.component';
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive';

import { InvestigatorFilterConfig } from '../investigator-transactions-filters/investigator-transactions-filters.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, CdkOverlayOrigin, ClickOutsideDirective, CdkConnectedOverlay],
  selector: 'aux-investigator-transactions-add-filter',
  templateUrl: './investigator-transactions-add-filter.component.html',
})
export class InvestigatorTransactionsAddFilterComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  isOpen = false;
  readonly originalOptionalFilters = [
    'Patient Group',
    'Protocol Version',
    'Description',
    'Country',
    'Category',
  ];
  optionalFilters = [...this.originalOptionalFilters];
  @Input() renderedFilters$!: BehaviorSubject<InvestigatorFilterConfig[]>;
  @Output() selectFilterChange = new EventEmitter<string>();
  @Input() showSourceColumn$!: Observable<boolean>;

  ngOnInit(): void {
    this.showSourceColumn$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((val) => {
      delete this.originalOptionalFilters[this.originalOptionalFilters.indexOf('Source', 0)];

      if (val) {
        this.originalOptionalFilters.push('Source');
      }
    });
    this.renderedFilters$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((list) => {
      this.optionalFilters = difference(
        this.originalOptionalFilters,
        list.map(({ label }) => label)
      );
    });
  }

  selectFilter(filterName: string) {
    this.toggleOpenList(false);
    this.selectFilterChange.emit(filterName);
    this.optionalFilters = this.optionalFilters.filter((name) => name !== filterName);
  }

  toggleOpenList = (value: boolean) => {
    this.isOpen = value;
  };
}
